import * as tslib_1 from "tslib";
import { mailStore } from 'owa-mail-store';
import tryRemoveFromMailStoreItems from 'owa-mail-actions/lib/triage/tryRemoveFromMailStoreItems';
import { action, select } from 'satcheljs/lib/legacy';
import { onDeleteConversationItemPartsComplete } from 'owa-mail-actions/lib/mailTriageActions';
export default action('deleteConversationItemParts')(select({
    conversations: function () { return mailStore.conversations; },
    conversationNodes: function () { return mailStore.conversationNodes; },
    items: function () { return mailStore.items; },
})(function deleteConversationItemParts(conversationId, state) {
    var e_1, _a, e_2, _b;
    if (state.conversations.has(conversationId)) {
        var conversationItemParts = state.conversations.get(conversationId);
        try {
            for (var _c = tslib_1.__values(conversationItemParts.conversationNodeIds), _d = _c.next(); !_d.done; _d = _c.next()) {
                var conversationNodeId = _d.value;
                var conversationNode = state.conversationNodes.get(conversationNodeId);
                try {
                    for (var _e = tslib_1.__values(conversationNode.itemIds), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var itemId = _f.value;
                        tryRemoveFromMailStoreItems(itemId, 1 /* ConversationItemParts */);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                state.conversationNodes.delete(conversationNodeId);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        state.conversations.delete(conversationId);
    }
    onDeleteConversationItemPartsComplete();
}));
//# sourceMappingURL=deleteConversationItemParts.js.map